import { Reveal } from "./Reveal";
import { WaButton } from "./WhatsAppIcon";
import { WA_DEFAULT_LINK } from "../constants/site";

export const FinalCta = () => (
    <section
        className="relative overflow-hidden bg-brand py-20 sm:py-28"
        data-testid="final-cta-section"
    >
        <div
            className="absolute inset-0 opacity-[0.08]"
            style={{
                backgroundImage:
                    "radial-gradient(circle at 1px 1px, #30343A 1.5px, transparent 0)",
                backgroundSize: "26px 26px",
            }}
            aria-hidden="true"
        />
        <div className="relative mx-auto max-w-4xl px-5 sm:px-8 text-center">
            <Reveal>
                <p className="font-technical font-semibold uppercase tracking-[0.22em] text-sm text-graphite/70">
                    Atendimento rápido pelo WhatsApp
                </p>
                <h2 className="mt-4 font-display font-black tracking-tight text-4xl sm:text-6xl text-white leading-[1.02]">
                    Sua geladeira volta a gelar hoje.
                </h2>
                <p className="mt-5 text-base sm:text-lg text-white/85 max-w-xl mx-auto">
                    Chame agora e receba um técnico especializado em Uberlândia.
                </p>
            </Reveal>
            <Reveal delay={0.12}>
                <div className="mt-9 flex justify-center">
                    <WaButton
                        href={WA_DEFAULT_LINK}
                        testId="final-whatsapp-cta"
                        className="bg-graphite hover:bg-graphite-dark shadow-[0_18px_40px_-10px_rgba(31,35,40,0.5)]"
                    >
                        Solicitar atendimento pelo WhatsApp
                    </WaButton>
                </div>
            </Reveal>
        </div>
    </section>
);
